// ekstrapazar · shopify teması: ürün rafları, hizalar, söz seçimi, oyun kaydı (9. tur ön izlemesinden) + ürün sayfası (adet, varyant, selam, sepete ekleme)
(function () {
  var az = matchMedia("(prefers-reduced-motion: reduce)").matches;
  document.querySelectorAll("[data-raf]").forEach(function (raf) {
    var sayfalar = raf.querySelectorAll(".raf-sayfa"), cikti = raf.querySelector("output"), i = 0, dur = false;
    function goster(n) {
      i = (n + sayfalar.length) % sayfalar.length;
      sayfalar.forEach(function (s, k) { s.hidden = k !== i; });
      if (cikti) cikti.textContent = (i + 1) + " / " + sayfalar.length;
    }
    raf.querySelectorAll("[data-yon]").forEach(function (b) { b.addEventListener("click", function () { goster(i + +b.dataset.yon); }); });
    ["mouseenter", "focusin"].forEach(function (o) { raf.addEventListener(o, function () { dur = true; }); });
    ["mouseleave", "focusout"].forEach(function (o) { raf.addEventListener(o, function () { dur = false; }); });
    if (!az && sayfalar.length > 1) setInterval(function () { if (!dur && !document.hidden) goster(i + 1); }, 7000);
  });
  // hizalar (8. tur): qr kartının sağ kenarı üstteki metnin "sizi" kelimesinin bitimiyle; hakkımızda banner'ının sağ kenarı
  // "teşekkür..”" noktalamasının bitimiyle aynı çizgide.. telefonda (tek sütun) uygulanmaz..
  var genis = matchMedia("(min-width: 48.01rem)");
  function hizala() {
    document.querySelectorAll("[data-hiza-sag]").forEach(function (e) {
      e.style.marginRight = "";
      var h = document.querySelector(e.dataset.hizaSag); if (!h || !genis.matches) return;
      e.style.marginRight = Math.max(0, e.getBoundingClientRect().right - h.getBoundingClientRect().right) + "px";
    });
    document.querySelectorAll("[data-hiza-genislik]").forEach(function (e) {
      e.style.width = "";
      var h = document.querySelector(e.dataset.hizaGenislik); if (!h || !genis.matches) return;
      var r = h.getClientRects(); r = r[r.length - 1];
      e.style.width = Math.round(r.right - e.getBoundingClientRect().left) + "px";
    });
  }
  hizala(); addEventListener("resize", hizala); if (document.fonts) document.fonts.ready.then(hizala);
  // söz alanı: verilen sözlerden biri her açılışta (reklam yoğunluğu sınırı: aynı sayfada en çok üç söz bandı)
  document.querySelectorAll("[data-soz-sec]").forEach(function (e) {
    var l = e.dataset.sozSec.split("|"); e.textContent = "“" + l[Math.floor(Math.random() * l.length)] + "”";
  });
  // dönen ilan (16 ekim 2026): her açılışta sıradaki ilandan başlar, ~7 sn'de bir döner; üzerine gelince, odakta ya da ekran dışında durur..
  // hareket azaltılmışsa kendiliğinden dönmez, noktalarla geçilir.. yalnız görünen ilanın görseli yüklenir (ötekiler gizli, geç yüklenir)
  document.querySelectorAll("[data-dongu]").forEach(function (d) {
    var k = [].slice.call(d.querySelectorAll("[data-kare]")); if (!k.length) return;
    var i = 0; try { i = (+(sessionStorage.getItem("ep-ilan") || -1) + 1) % k.length; sessionStorage.setItem("ep-ilan", i); } catch (e) { i = Math.floor(Math.random() * k.length); }
    var n = document.createElement("div"); n.className = "afis-noktalar";
    var b = k.map(function (x, j) { var e = document.createElement("button"); e.type = "button"; e.style.setProperty("--u", x.style.getPropertyValue("--u")); e.setAttribute("aria-label", (j + 1) + ". ilan: " + (x.dataset.marka || "")); e.addEventListener("click", function () { goster(j); }); n.appendChild(e); return e; });
    if (k.length > 1) d.appendChild(n);
    function goster(j) { i = (j + k.length) % k.length; k.forEach(function (x, m) { x.hidden = m !== i; }); b.forEach(function (e, m) { if (m === i) e.setAttribute("aria-current", "true"); else e.removeAttribute("aria-current"); }); }
    // ilanlar değişirken alan zıplamasın: en uzun ilanın boyu alanın en küçük boyu olur (görseller oranla yer tuttuğu için yüklenmeden ölçülür)
    function olc() { d.style.minHeight = ""; var h = 0; k.forEach(function (x, m) { k.forEach(function (y, t) { y.hidden = t !== m; }); h = Math.max(h, d.offsetHeight); }); d.style.minHeight = h + "px"; goster(i); }
    goster(i); olc(); d.classList.add("hazir"); addEventListener("resize", olc); if (document.fonts) document.fonts.ready.then(olc);
    if (az || k.length < 2) return;
    var dur = false, gorunur = true;
    ["mouseenter", "focusin"].forEach(function (o) { d.addEventListener(o, function () { dur = true; }); });
    ["mouseleave", "focusout"].forEach(function (o) { d.addEventListener(o, function () { dur = false; }); });
    if ("IntersectionObserver" in window) new IntersectionObserver(function (g) { gorunur = g[0].isIntersecting; }).observe(d);
    setInterval(function () { if (!dur && gorunur && !document.hidden) goster(i + 1); }, 7000);
  });
  document.querySelectorAll("video[data-kayit]").forEach(function (v) {
    var d = v.closest("figure").querySelector("[data-kayit-dugme]");
    function yaz() { d.textContent = v.paused ? "oynat" : "durdur"; d.setAttribute("aria-pressed", String(!v.paused)); }
    d.addEventListener("click", function () { if (v.paused) v.play().catch(function () {}); else v.pause(); });
    v.addEventListener("play", yaz); v.addEventListener("pause", yaz);
    if (!az && "IntersectionObserver" in window) new IntersectionObserver(function (g) { g.forEach(function (e) { if (e.isIntersecting) v.play().catch(function () {}); else v.pause(); }); }, { threshold: .4 }).observe(v);
    yaz();
  });
})();

// ürün sayfası
(function () {
  var form = document.querySelector("[data-urun-form]");
  if (!form) return;
  var adet = form.querySelector("[data-adet-deger]"), adetGiris = form.querySelector("input[name=quantity]");
  form.querySelectorAll("[data-adet]").forEach(function (b) {
    b.addEventListener("click", function () {
      // koli (17 ekim 2026): en az bir koli, adet koli koli artar
      var adim = Math.max(1, +adetGiris.dataset.koli || 1), enAz = Math.max(1, +adetGiris.dataset.enAz || 1, adim);
      var n = Math.max(enAz, (+adetGiris.value || enAz) + (+b.dataset.adet) * adim);
      adetGiris.value = n; if (adet) adet.textContent = n;
    });
  });
  // varyant: seçenekler birleşince doğru varyant kimliği, fiyatı ve stok durumu
  var veri = document.querySelector("[data-varyantlar]");
  var varyantlar = veri ? JSON.parse(veri.textContent) : [];
  var kimlik = form.querySelector("input[name=id]"), fiyat = document.querySelector("[data-fiyat]"), birim = document.querySelector("[data-birim]");
  var dugme = form.querySelector("[data-sepete]");
  function guncelle() {
    var secili = Array.prototype.map.call(form.querySelectorAll("[data-secenek]"), function (f) { var c = f.querySelector("input:checked"); return c ? c.value : null; });
    var v = varyantlar.find(function (x) { return x.options.every(function (o, i) { return o === secili[i]; }); });
    if (!v) return;
    kimlik.value = v.id;
    if (fiyat) fiyat.textContent = v.fiyat;
    if (birim) birim.innerHTML = v.birim || "";
    if (adetGiris && (+adetGiris.dataset.koli || 1) !== (v.koli || 1)) {
      adetGiris.dataset.koli = v.koli || 1;
      var ilk = Math.max(1, +adetGiris.dataset.enAz || 1, v.koli || 1);
      adetGiris.value = ilk; if (adet) adet.textContent = ilk;
    }
    if (dugme) { dugme.disabled = !v.available; dugme.textContent = v.available ? dugme.dataset.var : dugme.dataset.yok; }
    var u = new URL(location.href); u.searchParams.set("variant", v.id); history.replaceState(null, "", u);
  }
  form.querySelectorAll("[data-secenek] input").forEach(function (i) { i.addEventListener("change", guncelle); });

  // selam: karakter sayacı
  var not = form.querySelector("[data-selam-not]"), say = form.querySelector("[data-selam-say]");
  if (not && say) not.addEventListener("input", function () { say.textContent = not.value.length; });

  // sepete ekle: selam yazıldıysa kart ve paket ürünleri de eklenir (yönetimde seçildiyse); hata olursa not düşer
  var durum = form.querySelector("[data-sepet-durum]");
  form.addEventListener("submit", function (e) {
    if (!window.fetch) return;
    e.preventDefault();
    var fd = new FormData(form), ogeler = [], ozellik = {};
    fd.forEach(function (deger, ad) { var m = ad.match(/^properties\[(.+)\]$/); if (m && String(deger).trim()) ozellik[m[1]] = deger; });
    // selam yazıldıysa gönderenin alıcı bilgisi onayı gerekir (15 ekim 2026); selamsız siparişte onay satırı taşınmaz
    var onay = form.querySelector("[data-selam-onay]"), selamli = !!(ozellik["alıcı"] || ozellik["selam"]);
    if (onay && selamli && !onay.checked) { var sd = form.querySelector("[data-selam-durum]") || durum; if (sd) { sd.className = "form-not hata"; sd.textContent = "selam için alıcı bilgisi onayını işaretleyin.."; } onay.focus(); return; }
    if (!selamli) delete ozellik["alıcı bilgisi"];
    ogeler.push({ id: +fd.get("id"), quantity: +fd.get("quantity") || 1, properties: ozellik });
    form.querySelectorAll("[data-ek-urun]:checked").forEach(function (k) { if (ozellik["alıcı"] || ozellik["selam"]) ogeler.push({ id: +k.value, quantity: 1 }); });
    if (dugme) dugme.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ items: ogeler }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart"; })
      .catch(function (h) { if (durum) { durum.className = "form-not hata"; durum.textContent = (h && (h.description || h.message)) || durum.dataset.hata; } if (dugme) dugme.disabled = false; });
  });
})();

// sabit üst bölüm ve gezinme düğmeleri (16 ekim 2026)
(function () {
  var kok = document.documentElement, y = document.querySelector('[data-git="yukari"]'), ileri = document.querySelector('[data-git="ileri"]');
  var kaydi = false, ust = document.querySelector("header.ust"), bolum = ust && (ust.closest(".shopify-section") || ust);
  // daralma sayfanın boyunu değiştirmez (17 ekim 2026): üst bölüm ne kadar kısalırsa altına o kadar pay eklenir, aynı hızda..
  // boy değişince tarayıcı kaydırmayı geri çekiyor, eşiğin altına düşen üst bölüm yeniden büyüyor, logo titriyordu
  function durum(d) {
    kaydi = d;
    if (!bolum) { kok.classList.toggle("kaydi", d); return; }
    kok.classList.add("olc");
    var once = bolum.offsetHeight;
    kok.classList.toggle("kaydi", d);
    var sonra = bolum.offsetHeight;
    kok.classList.toggle("kaydi", !d);
    void bolum.offsetHeight;
    kok.classList.remove("olc");
    void bolum.offsetHeight;
    bolum.style.marginBottom = d ? Math.max(0, once - sonra) + "px" : "";
    kok.classList.toggle("kaydi", d);
  }
  function bak() {
    var s = scrollY;
    if (!kaydi && s > 120) durum(true); else if (kaydi && s < 20) durum(false);
    if (y) y.hidden = s < 600;
  }
  addEventListener("scroll", bak, { passive: true }); bak();
  // ileri: tarayıcı söylüyorsa ileride sayfa yokken soluk
  if (ileri && window.navigation && "canGoForward" in navigation) ileri.disabled = !navigation.canGoForward;
  document.querySelectorAll("[data-git]").forEach(function (b) {
    b.addEventListener("click", function () {
      var g = b.dataset.git;
      if (g === "yukari") { scrollTo({ top: 0, behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth" }); return; }
      if (g === "ileri") { history.forward(); return; }
      var ayni = document.referrer && document.referrer.indexOf(location.origin) === 0;
      if (history.length > 1 && ayni) history.back(); else location.href = "/";
    });
  });
})();


/* iletişim sayfasına konu ile gelinirse (ör. sipariş usulündeki "ben de isterim..", 16 ekim 2026): formun konusu o olur, formun üstünde yazar */
(function () {
  var konu = new URLSearchParams(location.search).get("konu");
  var form = document.getElementById("iletisim-form");
  if (!konu || !form) return;
  konu = konu.slice(0, 120);
  var gizli = form.querySelector('input[name="contact[konu]"]');
  if (!gizli || gizli.value !== "iletişim") return;
  gizli.value = konu;
  var not = document.createElement("p");
  not.className = "konu-notu";
  not.textContent = "konu: " + konu;
  form.prepend(not);
})();

// sepet: koli koli satılan ürünler (17 ekim 2026, şerbet).. adet koli katı değilse bir üst koliye tamamlanır ve not düşülür
(function () {
  var form = document.querySelector("form.sepet");
  if (!form) return;
  var not = form.querySelector("[data-sepet-koli]");
  function tamamla() {
    var degisti = false;
    form.querySelectorAll("input[data-koli]").forEach(function (g) {
      var k = +g.dataset.koli || 1, n = Math.max(0, Math.round(+g.value || 0));
      var d = n === 0 ? 0 : Math.ceil(n / k) * k;
      if (d !== +g.value) { g.value = d; degisti = true; }
    });
    if (degisti && not) not.textContent = not.dataset.not;
    return degisti;
  }
  // açılışta, her değişiklikte ve gönderirken: ödeme düğmesi de adetleri (updates[]) sepete işler, düzeltilmiş adetle ödemeye geçilir
  tamamla();
  form.querySelectorAll("input[data-koli]").forEach(function (g) { g.addEventListener("change", tamamla); });
  form.addEventListener("submit", tamamla);
})();

/* mağaza çubuğu sığmayınca kayar (21 ekim 2026; sections/gezgin.liquid): uçlarda ok ve solan kenar, tekerlekle yatay kaydırma, bulunulan mağaza görünürde */
(function () {
  var az = matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth";
  document.querySelectorAll("[data-gez-kaydir]").forEach(function (k) {
    var l = k.querySelector(".gez-liste"), sol = k.querySelector(".gez-ok.sol"), sag = k.querySelector(".gez-ok.sag");
    if (!l || !sol || !sag) return;
    function bak() {
      var bas = l.scrollLeft > 2, son = l.scrollLeft + l.clientWidth < l.scrollWidth - 2;
      k.classList.toggle("bas-var", bas); k.classList.toggle("son-var", son);
      sol.hidden = !bas; sag.hidden = !son;
    }
    [sol, sag].forEach(function (b) {
      b.addEventListener("click", function () { l.scrollBy({ left: +b.dataset.yon * Math.max(160, l.clientWidth * 0.7), behavior: az }); });
    });
    l.addEventListener("scroll", bak, { passive: true });
    l.addEventListener("wheel", function (e) {
      if (l.scrollWidth <= l.clientWidth || Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
      var once = l.scrollLeft; l.scrollLeft += e.deltaY;
      if (l.scrollLeft !== once) e.preventDefault();
    }, { passive: false });
    addEventListener("resize", bak);
    var simdi = l.querySelector('[aria-current]');
    if (simdi && simdi.offsetLeft + simdi.offsetWidth > l.clientWidth) l.scrollLeft = simdi.offsetLeft - (l.clientWidth - simdi.offsetWidth) / 2;
    bak();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(bak);
    addEventListener("load", bak);
  });
})();

// marka sitesinden gelen seçim (25 ekim 2026; bermekan numune kutusu, sections/urun-ana.liquid): ?secim=… satıra "seçim" özelliği olarak eklenir..
// yalnız düz yazı, en çok 300 harf; ziyaretçi sepete eklemeden önce görür
(function () {
  var g = document.querySelector("[data-secim-ozellik]"), n = document.querySelector("[data-secim-not]");
  if (!g || !n) return;
  var v = "";
  try { v = (new URLSearchParams(location.search).get("secim") || "").replace(/[<>]/g, "").replace(/\s+/g, " ").trim().slice(0, 300); } catch (h) {}
  if (!v) return;
  g.value = v; g.disabled = false;
  n.textContent = "seçiminiz: " + v; n.hidden = false;
})();
